<div class="detail-box">
  <div class="detail-box-main" *ngIf="version else versionloading">
    <div class="info">
      <header>
        <span class="version">{{version.version}}</span>
        <span class="id">(#{{version.id}})</span>
      </header>
      <div class="details">
        <p><strong>Uploaded on:</strong><em>{{version.date_created | date: 'dd MMM yyyy'}}</em></p>
        <p><strong>By:</strong><em>{{version.user_owner.name}}</em></p>
      </div>
    </div>
    <div class="status">
      <div class="status-main">
        <h3>This Artwork is</h3>
        <span [style.background-color]="version.status.color">{{version.status.name}}</span>
      </div>
    </div>
  </div>

  <ng-template #versionloading>
    <div class="loader">
      <div class="dimmed">
        <div class="dimmed_flex">
          <div class="dimmed_content dimmed_versions">
            <div class="dimmed_title"></div>
            <div class="dimmed_subtitle"></div>
            <div class="dimmed_subtitle"></div>
          </div>
          <div class="dimmed_status"></div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
